module.exports = __webpack_public_path__ + "static/media/pdc_icon.c6193004.svg";